import { render, staticRenderFns } from "./AppIndex.vue?vue&type=template&id=921bf95c"
import script from "./AppIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIndex.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports